import { render, staticRenderFns } from "./Layout_GLYF_pain_point.vue?vue&type=template&id=6ceafa10&scoped=true"
import script from "./Layout_GLYF_pain_point.vue?vue&type=script&lang=js"
export * from "./Layout_GLYF_pain_point.vue?vue&type=script&lang=js"
import style0 from "./Layout_GLYF_pain_point.vue?vue&type=style&index=0&id=6ceafa10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ceafa10",
  null
  
)

export default component.exports